import React from 'react';
import { withRouter, WithRouterProps, RouteProps } from 'react-router';
import { ChildProps } from 'react-apollo';
import MarketplacePage from './marketplace_page';
import { CoreAdBannerWrapper } from '../../schemas/rql';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { adBannerQuery } from '@reverbdotcom/commons/src/components/ads/ad_fragments';
import { parseKeywords } from '@reverbdotcom/commons/src/components/ads/ad_banner_helpers';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface IExternalProps {
  emptyGrid?: JSX.Element;
  showSold?: boolean;
  pageName?: MParticlePageName;
  route?: RouteProps<PropsFromRoute>;
}

interface PropsFromRoute {
  pageName: MParticlePageName;
}

type IProps = WithRouterProps & IUserContext & IExternalProps & ChildProps<{}, CoreAdBannerWrapper.Query> ;

const adQuery = withGraphql<IProps, CoreAdBannerWrapper.Query, CoreAdBannerWrapper.Variables>(adBannerQuery,
  {
    options: (ownProps) => {
      return {
        ssr: true,
        variables: { keywords: parseKeywords(ownProps.location, ownProps.params) },
      };
    },
  },
);

export function MarketplacePageWrapper({ 
  data,
  location, 
  params,
  pageName = MParticlePageName.Marketplace, 
  showSold = false, 
  emptyGrid = null,
  route, 
}: IProps) {
  return (
    <MarketplacePage
      location={location}
      params={params}
      pageName={route?.props?.pageName || pageName}
      showSold={showSold}
      emptyGrid={emptyGrid}
      adLoading={data?.loading}
      ad={data?.adServe?.ad}
    />
  );
}

export default withUserContext<IExternalProps>(withRouter(adQuery(MarketplacePageWrapper)));
